// Simple Microsoft OAuth without MSAL (fallback approach)
import { useState } from 'react';

const useSimpleMicrosoftLogin = ({ onLogin, onClose, setError }) => {
    const [loading, setLoading] = useState(false);

    const handleMicrosoftLogin = () => {
        if (loading) return;
        
        setLoading(true);
        setError('');

        try {
            const clientId = process.env.REACT_APP_MICROSOFT_CLIENT_ID;
            const redirectUri = `${window.location.origin}/social-callback`;
            const scope = encodeURIComponent("openid email profile");
            const state = encodeURIComponent(JSON.stringify({ 
                timestamp: Date.now(),
                returnUrl: "/dashboard", // Regular teacher login should always go to dashboard
                isAdmin: false // Flag to indicate this is regular teacher login
            }));

            // Use the standard OAuth URL without MSAL
            const authUrl = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?` +
                `client_id=${clientId}&` +
                `response_type=code&` +
                `redirect_uri=${encodeURIComponent(redirectUri)}&` +
                `response_mode=query&` +
                `scope=${scope}&` +
                `state=${state}&` +
                `prompt=select_account`;

            window.location.href = authUrl;
            
        } catch (error) {
            setError(`Microsoft login failed: ${error.message}`);
            setLoading(false);
        }
    };

    return { handleMicrosoftLogin, loading };
};

export default useSimpleMicrosoftLogin;